import { render, staticRenderFns } from "./UpdatePhoneNumberModal.vue?vue&type=template&id=1dfc6c5a"
import script from "./UpdatePhoneNumberModal.vue?vue&type=script&lang=js"
export * from "./UpdatePhoneNumberModal.vue?vue&type=script&lang=js"
import style0 from "./UpdatePhoneNumberModal.vue?vue&type=style&index=0&id=1dfc6c5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports